import type { PendingSave, PendingSaves } from "../../../common/input/pendingSaves";
import type { ContractState } from "../../../common/redux/reducers/contractReducer";
import { editContractThunk } from "../../../common/redux/thunks/contract/edit-contract-thunk";

export type HeldValues = PendingSave & {
  recheck: (contract: ContractState["contract"]) => Promise<unknown>;
  isHolding: () => boolean;
};

const isHeldValues = (pending: PendingSave): pending is HeldValues => "recheck" in pending && "isHolding" in pending;

export const recheckHeldValues = async (
  registry: PendingSaves | null,
  contract: ContractState["contract"] | undefined
): Promise<void> => {
  if (!registry || !contract) return;
  await Promise.all([...registry].filter(isHeldValues).map((held) => held.recheck(contract)));
};

export const recheckHeldValuesAfter = async (registry: PendingSaves | null, action: unknown): Promise<void> => {
  if (!editContractThunk.fulfilled.match(action as never)) return;
  await recheckHeldValues(registry, (action as ReturnType<typeof editContractThunk.fulfilled>).payload?.contract);
};

export const holdsUnsentValues = (registry: PendingSaves | null): boolean =>
  !!registry && [...registry].filter(isHeldValues).some((held) => held.isHolding());
